import { ComponentProps, FC } from 'react'
import { ModalCenter } from 'src/components'
import { ICampaignModel } from 'src/interfaces'
import { CampaignDetail } from '../campaign-detail'

interface IProps {
  campaign: Partial<ICampaignModel>
}

export const ModalCampaignDetail: FC<ComponentProps<typeof ModalCenter> & IProps> = ({ campaign, ...props }) => {
  return (
    <ModalCenter
      {...props}
      closeBtn
      contentClass="sm-p-4"
      contentStyles={{
        overflow: 'hidden',
        width: 880,
        maxWidth: '90vw',
        maxHeight: '80vh',
        background: '#F7F7F4'
      }}
    >
      <div className="fx-column h-100">
        <div className="pt-4"/>
        <div className="fx-1 overflow-auto">
          <CampaignDetail campaign={campaign}/>
        </div>
      </div>
    </ModalCenter>
  )
}
